<template>
  <a :href="url" :target="target" :title="title" :download="download">
    <slot name="before"></slot>
    <span v-if="!hideText">
      {{ text }}
    </span>
    <slot></slot>
  </a>
</template>

<script>
import * as lib from '../../../lib/lib'

export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
    hideText: {
      required: false,
      type: Boolean,
    },
  },
  computed: {
    text() {
      return this.item.title ? this.item.title : ''
    },
    url() {
      return this.item.url ? this.item.url : null
    },
    target() {
      return this.item.target ? this.item.target : '_parent'
    },
    download() {
      return this.item.download ? this.item.target : null
    },
    title() {
      return lib.hasValue(this.item.title) ? this.item.title : ''
    },
  },
}
</script>
